<template>
  <div>
    <div style="padding: 20px;">
      <div style="text-align: left; position: relative; margin-bottom: 10px;" v-if="!phoneVerify">
        <h3 style="margin-bottom: 10px; margin-top: -5px;">
          <!-- <mu-icon value="phone_iphone" style="margin-right: 5px; transform: translateY(5px);"></mu-icon>-->
          <i class="el-icon-phone"></i>
          {{ $t('Login.phone') }}
        </h3>
        <!-- 選擇國碼 -->
        <div style="margin-bottom: -5px;">
          <mu-select v-model="countryCode" :disabled="phoneVerify" style="width: 50%;">
            <mu-option v-for="(code, index) in countries" :key="index" :label="$t(code.text)" :value="code.value"></mu-option>
          </mu-select>
        </div>
        <!-- 輸入電話欄位 -->
        <mu-row gutter>
          <mu-col span="7">
            <mu-text-field v-model.trim="phone" full-width :placeholder="$t('Login.authHint')"></mu-text-field>
            <div v-if="phoneWarn" style="color: #f24; margin-top: -10px; margin-bottom: 10px;">{{ $t(warningMsg) }}</div>
          </mu-col>
          <mu-col span="5">
            <el-button type="primary" style="transform: translateY(-3px);" :disabled="phone === '' || number !== 0" @click="checkPhone">{{ $t('Login.verify') }}<span v-if="number !== 0"> {{ number }}</span></el-button>
          </mu-col>
          <div v-if="!phoneVerify" style="margin-left: 8px; transform: translateY(-8px);">{{ $t('Login.phoneExample') }}: {{ countries.filter(el => el.value === countryCode).map(el => el.example)[0] }}</div>
        </mu-row>
        <div>{{ debugText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      phone: '',
      debugText: '',
      countryCode: '886',
      phoneVerify: false,
      phoneWarn: false,
      warningMsg: '',
      countries:[
        { text: 'Login.taiwan', value: '886', example: '0912345678' },
        { text: 'Login.korea', value: '82', example: '01012341234' },
        { text: 'Login.cambodia', value: '855', example: '091234567' },
        { text: 'Login.malaysia', value: '60', example: '0149052502' }
      ],
    };
  },
  props: ['number', 'phoneNum', 'service', 'token'],
  computed: {
    ...mapGetters({
      pageData : 'pageData',
    })
  },
  mounted() {
    this.phone = this.phoneNum;
  },
  methods: {
    ...mapActions({ 
      checkPhoneUser: 'checkPhoneUser', // 檢查電話是否註冊
    }),
    checkPhone() {
      var re = /^[0-9]+$/;
      if (!re.test(this.phone)) { 
        this.phoneWarn = true;
        this.warningMsg = 'Login.informat_phone'; 
  　　 }
      else if (this.countryCode === '886' && this.phone.length !== 10) {
        this.phoneWarn = true;
        this.warningMsg = 'Login.informat_phone';
      }
      else {
        const loading = this.$loading({
          lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
        });
        this.checkPhoneUser({
          phone: this.phone,
          service: this.service,
          auth: this.pageData.auth,
          token: this.token
        })
        .then((res) => {
          loading.close();
          if (res.Message === '此電話已被註冊') {
            this.phoneWarn = true;
            this.warningMsg = 'Login.already_re'; 
          }
          else {
            this.phoneWarn  = false;
            this.warningMsg = '';
            this.$emit('getCountryCode', this.countryCode);
            this.$emit('sendSMS', this.phone);
          }
        })
      }
    }
  }
}

</script>